import { Component, DestroyRef, EventEmitter, inject, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmployerAuthFlow } from '../../../../../models/users/enum/employer-auth-flow.enum';
import { EmployerAuthViewModel } from './employer-auth-view-model';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-employer-auth',
  templateUrl: './employer-auth.component.html',
  providers: [EmployerAuthViewModel],
  styleUrls: ['./employer-auth.component.scss']
})
export class EmployerAuthComponent {
  private route = inject(ActivatedRoute);
  private viewModel = inject(EmployerAuthViewModel);
  private destroyRef = inject(DestroyRef);

  @Output() loadingOpts = new EventEmitter<LoadingOptions>();

  public showBackButton$ = this.viewModel.showBackButton$;
  public authFlow$ = this.viewModel.authFlow$;

  private listenToLoadingOpts = this.viewModel.loadingOpts$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(opts => this.loadingOpts.emit(opts));

  private listenToUrl = this.route.url.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
    next: url => {
      switch (url[url.length - 1].path) {
        case 'sign-in': {
          this.viewModel.setAuthFlow(EmployerAuthFlow.SignIn);
          break;
        }
        case 'forgot-password': {
          this.viewModel.setAuthFlow(EmployerAuthFlow.ForgotPassword);
          break;
        }
        case 'reset-password': {
          this.viewModel.setAuthFlow(EmployerAuthFlow.ResetPassword);
          break;
        }
        case 'employer-choose-password': {
          this.viewModel.setAuthFlow(EmployerAuthFlow.EmployerChoosePassword);
          break;
        }
        case 'verify-mfa': {
          this.viewModel.setAuthFlow(EmployerAuthFlow.EmployerMFAVerification);
          break;
        }
      }
    }
  });

  public goBack(): void {
    this.viewModel.goBack();
  }

  protected readonly EmployerAuthFlow = EmployerAuthFlow;
}
